import React from 'react';

/**
 * A simple button to open a lead in a new tab
 * This can be placed on any lead-related UI component (lead list, view modal, etc.)
 */
const OpenInNewTabButton = ({ leadId, onClose }) => {
  const handleClick = (event) => {
    // Use the temporary anchor link method for better cross-browser compatibility, especially Safari
    const link = document.createElement('a');
    link.href = `/leads/${leadId}`;
    link.target = '_blank';
    link.rel = 'noopener noreferrer'; // Security best practice
    document.body.appendChild(link); // Link needs to be in the DOM to be clicked
    link.click();
    document.body.removeChild(link); // Clean up the temporary link

    // Close the modal after attempting to open the new tab
    // No need for the pop-up blocker check here, as this method is less likely to be blocked silently
    if (onClose) {
      onClose();
    }
  };

  return (
    <button
      onClick={handleClick}
      className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
      title="Open in new tab"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" viewBox="0 0 20 20" fill="currentColor">
        <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z" />
        <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z" />
      </svg>
      Open in Tab
    </button>
  );
};

export default OpenInNewTabButton;
